// @flow
import ProductListSlider           from 'fg-frontend/components/ProductListSlider';
import EshopPhotogallery           from 'fg-frontend/components/EshopPhotogallery';
import EshopModel3D                from 'fg-frontend/components/EshopModel3D';
import EshopImageMagnify           from 'fg-frontend/components/EshopImageMagnify';
import EshopGalleryPopup           from 'fg-frontend/components/EshopGalleryPopup';
import EshopOrderForm              from 'fg-frontend/components/EshopOrderForm';
import EshopVariantStockHandler    from 'fg-frontend/src/components/EshopVariantStockHandler';

export default (props) => {
  switch (props.decorator || props.is) {
    case 'EshopPhotogallery':
      return EshopPhotogallery;
    case 'EshopModel3D':
      return EshopModel3D;
    case 'EshopImageMagnify':
      return EshopImageMagnify;
    case 'EshopGalleryPopup':
      return EshopGalleryPopup;
    case 'EshopOrderForm':
      return EshopOrderForm;
    case 'ProductListSlider':
      return ProductListSlider;

    // eshop - detail produktu - komponenta productDetailVariantForm - odkomentovat, pokud je na komponente nastaveno metadato <enableVariantStockHandler>true</enableVariantStockHandler>
    case 'EshopVariantStockHandler':
      return EshopVariantStockHandler;
  }
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureEshopComponents.js